require('!script-loader!./Prototype/prototype-minified.js')
//require('!script-loader!./Prototype/additions.js')

require('!script-loader!./jQuery/jquery-minified.js')
require('./jQuery/noconflict.js')

require('./jQuery/jquery.autoexpand.js')
require('./jQuery/jquery.identify.js')

require('./Fancybox/jquery.fancybox.js')
require('./Fancybox/jquery.easing.js')
require('./Fancybox/jquery.mousewheel.js')

// window.fetch Polyfill
require('whatwg-fetch')
